/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountDelegationsRequest
 */
export interface AccountDelegationsRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountDelegationsRequest
     */
    address: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDelegationsRequest
     */
    all: boolean;
    /**
     * 
     * @type {number}
     * @memberof AccountDelegationsRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof AccountDelegationsRequest
     */
    size: number;
}

export function AccountDelegationsRequestFromJSON(json: any): AccountDelegationsRequest {
    return AccountDelegationsRequestFromJSONTyped(json, false);
}

export function AccountDelegationsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDelegationsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'all': json['all'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function AccountDelegationsRequestToJSON(value?: AccountDelegationsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'all': value.all,
        'page': value.page,
        'size': value.size,
    };
}


